
import Vue from  'vue';

export default {

    /*mounted()
    {
        // Force paint
        document.body.offsetTop
        Vue.nextTick(this._start.bind(this))

        this.$el.classList.add('is-intro')
        console.log(this.$el.classList.toString())
    },*/

    /*methods: {

        _start()
        {
            setTimeout(this._endIntro.bind(this), 4000)
            console.log(this.$el.classList.toString())
        },

        _endIntro()
        {
            if (this.$el)
            {
                this.$el.classList.remove('is-intro')
                console.log(this.$el.classList.toString())
            }
        }
    }*//*,

    props: {
        classData : { type: String, default: '' }
    },

    datas: {
        classAdded : ''
    },

    created()
    {
        this.classAdded = this.classData
    }*/

}